<template>
    <div id="user">
        <v-container>
            <v-row class="justify-center">
                <h1>User</h1>
            </v-row>
        </v-container>
        <!-- <div>{{ userId }}</div>
        <div>{{ login  }}</div>
        <div>{{ firstname }}</div>
        <div>{{ email }}</div>
        <div>{{ password }}</div> -->
    </div>
</template>
<script>
// import $api from '../libs/race-app.js'
export default {
    name:'user',
    data(){
        return{
            //userId: this.$route.params.userId,
            // userId: this.$store.state.userData.id,
            // login: this.$store.state.userData.login,
            // firstname: this.$store.state.userData.firstname,
            // email: this.$store.state.userData.email,
            // password: this.$store.userData.password,
        }
    },
    mounted(){
        this.$store.dispatch('fetchUserData',1)
        .then(()=>{
            this.$store.dispatch('fetchAllUsersData')
            console.log("działa kurwa")
        })
        // $api.getUserData();


    //     let server ="https://raceapp.didevelopment.pl/api/User/get-by-id/1"
    //     let authToken ="Bearer ".concat(localStorage.token)
    //     console.log(authToken)
    //     const axiosConfig = {
    //     headers: {
    //     'content-Type': 'application/json',
    //     "Accept": "/",
    //     "Cache-Control": "no-cache",
    //     "Authorization": authToken, 
    //     }
    // };
    //     Vue.axios.get(server,axiosConfig).then((response) => {
    //         console.log(response.data)
    //     })

        // let auth = {authToken:"Bearer ".concat(localStorage.token)}        
        // console.log(auth);
        // axios.get('https://raceapp.didevelopment.pl/api/User/get-by-id/1',{},{ headers:{ "Authorization": auth.authToken,"x-dsi-restful":1 }})
        // .then(response => {
        //     this.$store.state.userData =  response.data
        // })
        // .catch(error =>{
        //     console.log(error)
        // })
    }
}
</script>
